import script from "./ppointsDeduc.vue?vue&type=script&setup=true&lang=js"
export * from "./ppointsDeduc.vue?vue&type=script&setup=true&lang=js"

import "./ppointsDeduc.vue?vue&type=style&index=0&id=b4f4c8cc&lang=scss"

const __exports__ = script;

export default __exports__